// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__1BW1s","light":"Panel_light__kamGT","frosted":"Panel_frosted__7B-wp","frostedWarm":"Panel_frostedWarm__-HhvI"};